const openNewWindow = (url: string, windowName?: string) => {
  window.open(
    url,
    windowName ?? window.name,
    `height=${window.innerHeight},width=${window.innerWidth}`,
  );
};
export default openNewWindow;
